import React , { memo } from 'react'
import BannerProgram from '../../../components/BannerProgram'

const goToZoom = (link) => {
    if (link) {
        const win = window.open(link, "_blank");
        win.focus();
    }
}

const checkingCondition = (event) => {
    let program_info = event?.program_info
    if (program_info?.is_active_elive === '1' && program_info?.zoom_link_elive) {
        return 'zoom'
    }
    if (program_info?.is_active_elive === '1' && program_info?.recording_link_elive) {
        return 'record'
    }
    return false
}

const BannerZoom = (props) => {
    const {
        eventState
    } = props
    let checking = checkingCondition(eventState)

    return (
        <div className="container">
            {
                checking === 'zoom' ?
                <div className="headWatch" >
                    <div className="d-flex">
                        <div className="headTimeSession">
                            <p style={{ color: 'red' }}>
                                {/* Lorem ipsum dolor sit amet consectetur adipisicing elit. Rem necessitatibus debitis iste facere. Soluta corrupti, laborum voluptatum porro non dicta sint quas deleniti consequatur nihil cumque facilis, nisi nemo! Dolore. */}
                            </p>
                        </div>
                        <div className="watchZoom">								
                            <div className="customNavigation" style={{ width: '7rem' }}>
                                <div
                                    className={!(eventState?.program_info?.is_active_elive) ? "zoomActionDisabled" : 'zoomAction'}
                                    onClick={_=> goToZoom(eventState?.program_info?.zoom_link_elive)}
                                >
                                    {/* <!-- if session close replace button go to feedback--> */}
                                    <span style={{display: 'initial'}}>
                                        <i className="fas fa-video"></i> Go to Zoom 
                                    </span>
                                    {/* <!-- feedback */}
                                    {/* <a href="">
                                        <i className="far fa-keyboard"></i> Leave Feedback 
                                    </a> */}
                                    {/* --> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                checking === 'record' &&
                <div className="ratio ratio-16x9">
                    <BannerProgram eventState={eventState} />
                </div>
            }
        </div>
    )
};

export default memo(BannerZoom);
